module.exports = __webpack_public_path__ + "img/W-28.94c7f5c1.jpg";